import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useState } from 'react';
import { TooltipWrapper, TooltipButton } from './style.js';
import TooltipComponent from './tooltipPopover.js';

var Tooltip = function Tooltip(_a) {
  var children = _a.children,
      triggerEvent = _a.triggerEvent,
      content = _a.content,
      _b = _a.targetElement,
      targetElement = _b === void 0 ? '' : _b,
      _c = _a.placement,
      placement = _c === void 0 ? 'auto' : _c,
      id = _a.id,
      _d = _a.visible,
      visible = _d === void 0 ? false : _d,
      triggerAs = _a.triggerAs,
      rest = __rest(_a, ["children", "triggerEvent", "content", "targetElement", "placement", "id", "visible", "triggerAs"]);

  var _e = useState(null),
      referenceElement = _e[0],
      setReferenceElement = _e[1];

  var _f = useState(visible),
      tooltipVisible = _f[0],
      setToolTipVisible = _f[1];

  var showTooltip = function showTooltip() {
    setToolTipVisible(true);
  };

  var hideTooltip = function hideTooltip() {
    setToolTipVisible(false);
  };

  var triggerProps = {
    onMouseOver: function onMouseOver() {
      return showTooltip();
    }
  };

  if (triggerEvent === 'click') {
    triggerProps = {
      onClick: function onClick() {
        return showTooltip();
      }
    };
  }

  var asProps = {};

  if (triggerAs) {
    asProps = {
      as: triggerAs
    };
  }

  var ariaProps = {};

  if (tooltipVisible) {
    ariaProps = {
      'aria-describedby': id
    };
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TooltipWrapper, __assign({
    triggerEvent: triggerEvent
  }, triggerProps, {
    onMouseLeave: function onMouseLeave() {
      return hideTooltip();
    },
    onBlur: function onBlur() {
      return hideTooltip();
    },
    ref: setReferenceElement
  }, rest), /*#__PURE__*/React.createElement(TooltipButton, __assign({}, asProps, {
    tabIndex: 0,
    onFocus: function onFocus() {
      return showTooltip();
    }
  }, ariaProps), children)), tooltipVisible && /*#__PURE__*/React.createElement(TooltipComponent, {
    id: id,
    placement: placement,
    targetElement: targetElement,
    referenceElement: referenceElement,
    content: content
  }));
};

Tooltip.displayName = 'Tooltip';
export default Tooltip;